(function () {
  'use strict';
  var root = document.querySelector('[data-reading-product]');
  if (!root || root.getAttribute('data-question-validation-ready') === 'true') return;
  var form = root.querySelector('.drp__form');
  var question = form && form.querySelector('textarea[name="properties[Your Question]"]');
  if (!question) return;
  root.setAttribute('data-question-validation-ready', 'true');
  var locale = String(document.documentElement.lang || root.getAttribute('data-reading-language') || 'en').toLowerCase();
  var language = locale.split('-')[0];
  var copy = {
    en: 'Write one focused question using {min}–{max} characters. Spaces alone do not count.',
    tr: '{min}–{max} karakterle tek ve net bir soru yazın. Yalnızca boşluklar yeterli değildir.',
    de: 'Schreibe eine klare Frage mit {min}–{max} Zeichen. Leerzeichen allein zählen nicht.',
    es: 'Escribe una pregunta concreta de {min} a {max} caracteres. Los espacios solos no cuentan.',
    'pt-br': 'Escreva uma pergunta clara com {min} a {max} caracteres. Apenas espaços não contam.',
    pt: 'Escreva uma pergunta clara com {min} a {max} caracteres. Só os espaços não contam.'
  };
  var min = Number(question.getAttribute('minlength')) || 12;
  var max = Number(question.getAttribute('maxlength')) || 600;
  var message = (copy[locale] || copy[language] || copy.en).replace('{min}', String(min)).replace('{max}', String(max));
  function validate() {
    var length = String(question.value || '').replace(/\s+/g, ' ').trim().length;
    var valid = length >= min && length <= max;
    question.setCustomValidity(valid ? '' : message);
    return valid;
  }
  question.addEventListener('input', validate);
  question.addEventListener('change', validate);
  form.addEventListener('submit', function (event) {
    if (validate()) return;
    event.preventDefault();
    question.reportValidity();
    try { question.focus({ preventScroll: true }); } catch (_) { question.focus(); }
  }, true);
  validate();
})();
